import { Container } from "@mui/material"
import LaancStyles from '../styles/LaancStatment.module.css'

function LaancStatement (){
    return(
        <Container className={LaancStyles.statement_body}>

            <h1 className={LaancStyles.statement_h1}>LAANC Statement</h1>

            <p className={LaancStyles.statement_p}>Effective Date: July 13, 2024</p>
            <p className={LaancStyles.statement_p}>
                Flyzone is a provider of UAS services within the FAA’s Low-Altitude Authorization and Notification Capability (LAANC). LAANC may be used to satisfy compliance with air traffic authorization. Information provided here is based on real-time and available projected information on airspace status and airport-specific maps, and that information is subject to change. Planning tools should be checked prior to flight for any changes that could impact the operation.
            </p>
            <p className={LaancStyles.statement_p}>
                Flyzone cannot ensure the completion or accuracy of all displayed TFR data. Remote pilots are responsible for checking the airspace they are operating in per Part 107.49 and complying with all restrictions that may be present such as restricted and prohibited airspace, temporary flight restrictions, etc. To obtain the most accurate and up to date information operators should check tfr.faa.gov and ensure their operation(s) do not overlap with any active TFRs or other restricted airspaces prior to launch.
            </p>
        </Container>
    )
}

export default LaancStatement